const article = `
{settings}
document.title: Fentanylkrisen i Estland
og.title: Fentanylkrisen i Estland
og.image: http://quickshot.imgix.net/fentanyl-estland/trapp.jpg?fit=crop&w=1200&h=628&fp-y=.3&fp-z=1
og.description: SVT i Estland – ett land hårt drabbat av dödsdrogen fentanyl
og.url: http://pejl.svt.se/fentanylkrisen-i-estland
siteCatalyst.name: fentanylkrisen-i-estland
siteCatalyst.category: lyxartikel
{}

[+page]
rubrikneg: ”En dos kan göra dig hög – eller döda dig”

{.bild}
fil: fentanyl-estland/start-cinema.jpg
storlek: imax
{}

rubrikmager: SVT:s Bengt Norborg i fentanyl-drabbade Estland

ingressmulti: Karl vinglar, vacklar, fram till Kaur som kramar om honom.
ingressmulti: Karl sätter sig försiktigt ner på trappstegen utanför ett förfallet, igenbommat hus i centrala Tallinn.
ingressmulti:Han sluter ögonen och ser ut som om han ska somna sittande.
ingressmulti:– Är du inte rädd att dö? frågar Kaur.
ingressmulti:– När nålen går in i armen tänker man inte på det, säger Karl svagt.
{.bild}
fil: fentanyl-estland/trapp.jpg
storlek: square
bildtext: Författaren och bloggaren Kaur Kender engagerar sig i Estlands missbrukare. Här träffar han Karl, 26, som har överdoserat på fentanyl 40 gånger.
foto: Bengt Norborg
{}
Karl är 26 år och har knarkat i tio. Han har för bara en liten stund sedan ännu en gång räddats av sjukvårdspersonal efter sin 40:e överdos av dödsdrogen fentanyl.

Vårt grannland Estland, med bara 1,3 miljoner invånare, har dom högsta drogrelaterade dödstalen i hela EU – i huvudsak orsakade av den syntetiska opioiden fentanyl, en heroin-liknande drog framställd i laboratorium.
I början var fentanyl en smärtstillare som kunde användas efter operationer. Men när drogen också började framställas i kriminella kretsar blev den snabbt en lönsam affär för amatörkemister, illegala handlare på nätet och drogkarteller som kunde distribuera knarket till missbrukarna.
Den blev ett nytt billigt alternativ och slog snabbt ut heroinet på den estniska marknaden.

– En dos kostar tio euro. Den kan göra dig hög – eller döda dig, säger Kaur Kender.

mellanrubrik: Vill förändra knarklagen
Han är författare och bloggare och rejält engagerad för en förändrad knarklagstiftning. Han har demonstrerat, uppvaktat politiker i parlamentet och sett till att missbrukarna själva kunnat göra sin stämma hörd.
{.citat}
citat: Brukarna kläms stenhårt mellan en tuff polismakt och livsfarliga handlare
stil:strong
{}
En ung knarkare inspirerades av Kaur att skriva en bok som blev en bästsäljare här.
– Brukarna kläms stenhårt mellan en tuff polismakt och livsfarliga handlare och jag vill hjälpa dom unga som riskerar att gå under, säger Kaur som provat allt utom fentanyl.
Han är kontroversiell men tycks ha mångas förtroende också.
– Jag ljuger inte, jag berättar historier Estland inte vill höra, säger han.

mellanrubrik: 100 gånger starkare

Beroende på koncentrationen så kan en vanlig dos, som injiceras, röks eller tas i tablettform, vara kanske 100 gånger starkare än en dos heroin.
Därför dör missbrukare i rena epidemier runtom i världen när extra potent fentanyl finns på marknaden. Och av någon anledning är det värst i Estland.

{.bild}
fil: fentanyl-estland/drog.jpg
storlek: s
{}


Kaur kör runt i sin stora bil, pekar och berättar. Vi är i Narva.
På andra sidan floden ligger Ryssland och esterna har satt upp ett minnesmärke, ett lejon med tassen på en kula, över svenskarna som under Karl XII besegrade den flera gånger större rysk armén här år 1700. Kanske en försiktig provokation av lilla Estland: musen som röt mot björnen i öster.

mellanrubrik: ”Fentanyl ett jätteproblem”
Den medeltida ryska fästningen på andra sidan gränsfloden tornar fortfarande upp sej ovanför lilla Narva.

– Här i Narva är den ryska minoriteten i Estland störst, så fentanyl är ett jätteproblem. Vi har en lika hög hiv-frekvens som på vissa håll i Afrika, och ryssarna är överrepresenterade i fängelserna, säger Kaur.

Vi kör längs långa hyreskaserner, uppförda under sovjettiden, det är ont om bilar och människor på gatorna. Folk flyr, menar Kaur. En lägenhet kostar 3 000 euro, billigare än en bil, ändå drar dom unga till Tallinn.
{.citat}
citat: Vi har en lika hög hiv-frekvens som på vissa håll i Afrika, och ryssarna är överrepresenterade i fängelserna
stil:strong
{}

För den unga ryska minoriteten är arbetsmarknaden ännu hårdare än för esterna. Kanske är det en förklaring till att fentanyl-problemet främst är ett ryskt problem. Kanske kommer också drogen från Ryssland, men ingen vet. Så gott som inga beslag har gjorts och den kan lika gärna framställas här i landet.
För Kaur är regeringens politik gentemot de över 300.000 ryssarna också en förklaring.

– En stor minoritet kommer inte in, och vi talar om vanliga människor som staten skadar. Vi har ett slags strukturell rasism här som på sikt kan slita sönder landet, säger han.

{.bild}
fil: fentanyl-estland/vy.jpg
storlek: wide
bildtext: Från att ha varit ett problem främst hos den ryska minoriteten sprider sig nu fentanylbruket bland den estniska befolkningen.
foto: Bengt Norborg
{}

Tillbaka i Tallinn där turistgrupperna drar omkring i den välrenoverade gamla stan. Den pittoreska stadskärnan står i skarp kontrast till nedgångna, nedbrunna, nedklottrade hyreslängor nere vid hamnarna och varven som en gång sysselsatte tusentals människor.

mellanrubrik: Dödsdrogen sprider sig
Här syns spåren efter knarkande och prostitution. Och från att ha varit ett problem främst hos den ryska minoriteten har fentanylen spritt sej in i den estniska befolkningen.
Men med tiden kommer det här norra distriktet i Tallinn att rivas och renoveras.
Frågan är väl vilka som kommer att kunna flytta in och vart ”samhällets olycksbarn” ska ta vägen.

För Kaur är det enkelt: Legalisering och hjälp eller vård, bara då kan handeln upphöra.
Det är förstås politiskt kontroversiellt, även om länder som Schweiz, Portugal och Danmark går i bräschen. Men det finns också positiva tecken i Estland numera, som kliniker och sprutbytes program.

{.citat}
citat: Det är inte effektivt att straffa missbrukarna, de behöver hjälp. Kriget mot knarket är ett misslyckande över hela världen. Det finns inget sunt förnuft i det.
av: Raimond Kaljulaid, stadsdelschef, norra Tallinn.
stil:strong
{}

{.luft}
marginal:30px
{}



rubrik5: Bengt Norborg
{.luft}
marginal: -40
{}
rubrik5: [ bengt.norborg@svt.se | mailto:bengt.norborg@svt.se ]
25 oktober 2016

linje:
rubrikmager: ▸ Se Bengt Norborgs reportage [20.00 i SVT2|strong] eller på [SVT Play|http://play.svt.se]

{.sharebuttons}
title: SVT i Estland – ett land hårt drabbat av dödsdrogen fentanyl
url: http://pejl.svt.se/fentanylkrisen-i-estland
{}


[]
`;

export default article;



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/data/articles/estland-fentanyl.js
 **/